module.exports = __webpack_public_path__ + "img/698.3b0607ab.png";